import type {
  Country
} from 'react-phone-number-input'

export type Store = {
  id: number
  prefix: string
  locale: string
  region_code: string
  labels: {
    region: string
    language: string
  }
  order: number
  callingCode: Country
  slugs: {
    news: string,
    events: string,
    celebrities: string,
    messikatv: string,
    thisism: string,
    ourBoutiques: string,
    trackingOrder: string,
  },
  isDefault?: boolean
  isHidden?: boolean
}

// Data from magento BO
export const stores: Store[] = [
  {
    id: 15,
    prefix: 'ch_cn',
    locale: 'zh-Hans',
    region_code: 'cn',
    labels: {
      region: 'Messika Chine',
      language: '简体中文',
    },
    order: 100,
    callingCode: 'CN',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 1,
    prefix: 'fr',
    locale: 'fr',
    region_code: 'eu',
    labels: {
      region: 'Messika Europe',
      language: 'Français',
    },
    order: 10,
    callingCode: 'FR',
    slugs: {
      news: 'actualites',
      events: 'evenements',
      celebrities: 'celebrites',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'nos-boutiques',
      trackingOrder: 'suivi-commande',
    },
    isDefault: true,
  },
  {
    id: 2,
    prefix: 'en',
    locale: 'en',
    region_code: 'eu',
    labels: {
      region: 'Messika Europe',
      language: 'English',
    },
    order: 20,
    callingCode: 'GB',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 13,
    prefix: 'de',
    locale: 'de',
    region_code: 'eu',
    labels: {
      region: 'Messika Europe',
      language: 'Deutsch',
    },
    order: 30,
    callingCode: 'DE',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'prominente',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'unsere-boutiquen',
      trackingOrder: 'bestellverfolgung',
    },
  },
  {
    id: 17,
    prefix: 'es',
    locale: 'es',
    region_code: 'eu',
    labels: {
      region: 'Messika Europe',
      language: 'Español',
    },
    order: 40,
    callingCode: 'ES',
    slugs: {
      news: 'news',
      events: 'eventos',
      celebrities: 'celebridades',
      messikatv: 'messikatv',
      thisism: 'todosobrem',
      ourBoutiques: 'nuestras-boutiques',
      trackingOrder: 'seguimiento-pedido',
    },
  },
  {
    id: 21,
    prefix: 'it',
    locale: 'it-IT',
    region_code: 'eu',
    labels: {
      region: 'Messika Europe',
      language: 'Italiano',
    },
    order: 50,
    callingCode: 'IT',
    slugs: {
      news: 'notizie',
      events: 'eventi',
      celebrities: 'celebrita',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 20,
    prefix: 'hk_en',
    locale: 'en-HK',
    region_code: 'hk',
    labels: {
      region: 'Messika Hong Kong SAR China',
      language: 'English',
    },
    order: 110,
    callingCode: 'HK',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 12,
    prefix: 'jp_ja',
    locale: 'ja-JP',
    region_code: 'jp',
    labels: {
      region: 'Messika Japan',
      language: '日本語',
    },
    order: 90,
    callingCode: 'JP',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 22,
    prefix: 'kr_kr',
    locale: 'ko-KR',
    region_code: 'kr',
    labels: {
      region: 'Messika Korea',
      language: '한국어',
    },
    // No set in the BO
    order: 10000,
    callingCode: 'KR',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 23,
    prefix: 'sa_ar',
    locale: 'ar',
    region_code: 'sa',
    labels: {
      region: 'Messika Saudi Arabia',
      language: 'العربية',
    },
    // No set in the BO
    order: 10100,
    callingCode: 'SA',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 24,
    prefix: 'sa_en',
    locale: 'en-SA',
    region_code: 'sa',
    labels: {
      region: 'Messika Saudi Arabia',
      language: 'English',
    },
    // No set in the BO
    order: 10200,
    callingCode: 'SA',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 19,
    prefix: 'ar_en',
    locale: 'en-AE',
    region_code: 'ae',
    labels: {
      region: 'Messika United Arab Emirates',
      language: 'English',
    },
    order: 160,
    callingCode: 'AE',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 18,
    prefix: 'ar_ar',
    locale: 'ar-AE',
    region_code: 'ae',
    labels: {
      region: 'Messika United Arab Emirates',
      language: 'العربية',
    },
    order: 170,
    callingCode: 'AE',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 3,
    prefix: 'uk_en',
    locale: 'en-GB',
    region_code: 'gb',
    labels: {
      region: 'Messika United Kingdom',
      language: 'English',
    },
    order: 60,
    callingCode: 'GB',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 4,
    prefix: 'us_en',
    locale: 'en-US',
    region_code: 'us',
    labels: {
      region: 'Messika United States',
      language: 'English',
    },
    order: 50,
    callingCode: 'US',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 5,
    prefix: 'tu_en',
    locale: 'en-TR',
    region_code: 'tr',
    labels: {
      region: 'Messika Turquie',
      language: 'English',
    },
    order: 130,
    callingCode: 'TR',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 6,
    prefix: 'su_fr',
    locale: 'fr-CH',
    region_code: 'ch',
    labels: {
      region: 'Messika Suisse',
      language: 'Français',
    },
    order: 70,
    callingCode: 'CH',
    slugs: {
      news: 'actualites',
      events: 'evenements',
      celebrities: 'celebrites',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'nos-boutiques',
      trackingOrder: 'suivi-commande',
    },
  },
  {
    id: 8,
    prefix: 'su_en',
    locale: 'en-CH',
    region_code: 'ch',
    labels: {
      region: 'Messika Suisse',
      language: 'English',
    },
    order: 80,
    callingCode: 'CH',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 7,
    prefix: 'ru_en',
    locale: 'en-RU',
    region_code: 'ru',
    labels: {
      region: 'Messika Russie',
      language: 'English',
    },
    order: 110,
    callingCode: 'RU',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 14,
    prefix: 'ru_ru',
    locale: 'ru-RU',
    region_code: 'ru',
    labels: {
      region: 'Messika Russie',
      language: 'Русский',
    },
    order: 120,
    callingCode: 'RU',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 1,
    prefix: 'ci_fr',
    locale: 'fr-CI',
    region_code: 'ci',
    labels: {
      region: "Messika Côte d'Ivoire",
      language: "Français",
    },
    order: 140,
    callingCode: 'CI',
    slugs: {
      news: 'actualites',
      events: 'evenements',
      celebrities: 'celebrites',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'nos-boutiques',
      trackingOrder: 'suivi-commande',
    },
  },
  {
    id: 1,
    prefix: 'ci_en',
    locale: 'en-CI',
    region_code: 'ci',
    labels: {
      region: "Messika Côte d'Ivoire",
      language: 'English',
    },
    order: 150,
    callingCode: 'CI',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
  {
    id: 25,
    prefix: 'au_en',
    locale: 'en-AU',
    region_code: 'au',
    labels: {
      region: "Messika Australia",
      language: 'English',
    },
    order: 160,
    callingCode: 'AU',
    slugs: {
      news: 'news',
      events: 'events',
      celebrities: 'celebrities',
      messikatv: 'messikatv',
      thisism: 'thisism',
      ourBoutiques: 'our-boutiques',
      trackingOrder: 'tracking-order',
    },
  },
];

stores.sort((a, b) => {
  if (a.order > b.order) {
    return 1
  } else if (a.order < b.order) {
    return -1
  }
  if (a.region_code > b.region_code) {
    return 1
  } else if (a.region_code < b.region_code) {
    return -1
  }
  if (a.labels.language > b.labels.language) {
    return 1
  }
  return -1
})

export const boutiqueSlugs = [] as string[];
export const suiviSlugs = [] as string[];
stores.forEach((s) => {
  if (!boutiqueSlugs.includes(s.slugs.ourBoutiques)) {
    boutiqueSlugs.push(s.slugs.ourBoutiques);
  }
  if (!suiviSlugs.includes(s.slugs.trackingOrder)) {
    suiviSlugs.push(s.slugs.trackingOrder);
  }
});

export const defaultStore = stores.find((s) => s.isDefault) as Store

export default stores
